var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import OmbudsmanCard from "./OmbudsmanCard";
var cards = [
    {
        icon: {
            iconName: "MessageCircle",
            iconBg: "bg-[#C1EED3]",
            iconColor: "text-[#167974]",
        },
        title: "WhatsApp",
        description: "Entre em contato com a Ouvidoria ETIPI pelo WhatsApp.",
        href: "https://wa.me/5586994636716",
        buttonLabel: "Falar no WhatsApp",
    },
    {
        icon: {
            iconName: "ThumbsUp",
            iconBg: "bg-[#EDF7F9]",
            iconColor: "text-[#6DBECE]",
        },
        title: "Elogio",
        description: "Expresse se você está satisfeito com um atendimento público.",
        href: "https://falabr.cgu.gov.br/web/login?tipo=3&redirect=/v-app/manifestacao/criar?tipo=3",
        buttonLabel: "Acessar Fala.BR",
    },
    {
        icon: {
            iconName: "ThumbsDown",
            iconBg: "bg-[#F6E7E8]",
            iconColor: "text-[#C96E74]",
        },
        title: "Reclamação",
        description: "Manifeste sua insatisfação com um serviço público.",
        href: "https://falabr.cgu.gov.br/web/login?tipo=2&redirect=/v-app/manifestacao/criar?tipo=2",
        buttonLabel: "Acessar Fala.BR",
    },
    {
        icon: {
            iconName: "FilePenLine",
            iconBg: "bg-[#E8F1E9]",
            iconColor: "text-[#81B287]",
        },
        title: "Solicitação",
        description: "Solicite a adoção de providências por parte de uma Ouvidoria.",
        href: "https://falabr.cgu.gov.br/web/login?tipo=5&redirect=/v-app/manifestacao/criar?tipo=5",
        buttonLabel: "Acessar Fala.BR",
    },
    {
        icon: {
            iconName: "MessageCircle",
            iconBg: "bg-[#FFF8EA]",
            iconColor: "text-[#FFBF3F]",
        },
        title: "Sugestão",
        description: "Envie uma ideia ou proposta de melhoria para os serviços públicos.",
        href: "https://falabr.cgu.gov.br/web/login?tipo=4&redirect=/v-app/manifestacao/criar?tipo=4",
        buttonLabel: "Acessar Fala.BR",
    },
    {
        icon: {
            iconName: "Megaphone",
            iconBg: "bg-[#FFECE7]",
            iconColor: "text-[#FF653D]",
        },
        title: "Denúncia",
        description: "Informe um ato ilícito ou irregularidade na administração pública.",
        href: "https://falabr.cgu.gov.br/web/login?tipo=1&redirect=/v-app/manifestacao/criar?tipo=1",
        buttonLabel: "Acessar Fala.BR",
    },
    {
        icon: {
            iconName: "FileCheck2",
            iconBg: "bg-[#EDF7F9]",
            iconColor: "text-[#478BFF]",
        },
        title: "Simplifique",
        description: "Sugira alguma ideia para desburocratizar o serviço público.",
        href: "".concat(process.env.PORTAL_URL, "/app/app-simplifique"),
        buttonLabel: "Entrar com Gov.pi",
    },
    {
        icon: {
            iconName: "Info",
            iconBg: "bg-[#E3E5E9]",
            iconColor: "text-[#8991A2]",
        },
        title: "Acesso à informação",
        description: "Faça um pedido de acesso à informação pública.",
        href: "https://falabr.cgu.gov.br/web/login?tipo=8&redirect=/v-app/manifestacao/criar?tipo=8",
        buttonLabel: "Acessar Fala.BR",
    },
];
export default function Ombudsman() {
    return (_jsxs("div", __assign({ className: "flex flex-col items-center gap-6 w-full" }, { children: [_jsxs("div", __assign({ className: "text-center flex flex-col md:space-y-0 space-y-6" }, { children: [_jsx("h1", __assign({ className: "text-[#262626] md:text-3xl font-bold text-xl text-balance" }, { children: "Ouvidoria" })), _jsx("p", __assign({ className: "text-fg-moderate-default md:text-[14px] md:leading-relaxed tracking-wide text-base text-balance" }, { children: "Escolha a op\u00E7\u00E3o que melhor se encaixa no que voc\u00EA procura" }))] })), _jsx("div", __assign({ className: "grid md:grid-cols-2 lg:grid-cols-4 grid-cols-1 gap-4" }, { children: cards.slice(0, 4).map(function (card) { return (_jsx(OmbudsmanCard, __assign({}, card), card.title)); }) })), _jsx("div", __assign({ className: "grid md:grid-cols-2 lg:grid-cols-4 grid-cols-1 gap-4" }, { children: cards.slice(4).map(function (card) { return (_jsx(OmbudsmanCard, __assign({}, card), card.title)); }) }))] })));
}
